import { createContext, useContext } from "react"

import { ApiHomeResponse } from "./types/ApiHomeResponse"

type AppDataType = StaticContext & ApiHomeResponse
const AppDataContext = createContext<AppDataType>({} as never)

export const AppGlobalsProvider = AppDataContext.Provider

export const useAppData = (): AppDataType => {
  return useContext(AppDataContext)
}

export const useTextContent = (key: string): null | string => {
  const context = useAppData()

  if (!context || !context.textContent) {
    return null
  }

  const text = context.textContent.find((item) => key === item.key)
  if (!text || !text.value) {
    return null
  }

  return text.value
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useStaticLink = (key: string): any => {
  const context = useAppData()

  if (!context || !context.links) {
    return null
  }

  // @ts-expect-error legacy
  return context.links[key]
}

export const STATIC_CONTEXT = {
  contacts: {
    heading: {
      ru: "Свяжитесь с&nbsp;нами",
      en: "Contact us",
    },
    ekb: {
      ru: "Почтовый адрес",
      en: "Address",
    },
    email: {
      ru: "hello@dabb.ru",
      en: "hello@dabb.pro",
    },
    phoneMain: {
      ru: {
        text: "7 (495) 120-99-68",
        href: "+74951209968",
      },
      en: {
        text: "381 63 1820801",
        href: "+381631820801",
      },
    },
    phoneAdditional: {
      text: "7 (343) 266-40-69",
      href: "+73432664069",
    },
    address: {
      ru:
        "620026, г.&nbsp;Екатеринбург,<br /> ул.&nbsp;Энгельса,&nbsp;д.&nbsp;36,&nbsp;оф.&nbsp;527",
      en:
        "Beavers Global DOO<br /> Novosadskog sajma 2 <br /> 3rd floor, EWA IT Hub <br /> Novi Sad, Serbia 21101",
    },
    companyName: {
      ru: "",
      en: "Beavers Global DOO",
    },
    footer: {
      ru: `&copy;&nbsp;2014&ndash;${new Date().getFullYear()} Digital-агентство Beavers&nbsp;Brothers
        <br />
        <br />`,
      en: `&copy;&nbsp;${new Date().getFullYear()} Beavers Global DOO`,
    },
  },
  links: {
    services: {
      title: { ru: "Услуги", en: "Services" },
      href: "/services",
    },
    process: {
      title: { ru: "Как мы работаем", en: "How we work" },
      href: "/process",
    },
    about: {
      title: { ru: "О нас", en: "About us" },
      href: "/about",
    },
    awards: {
      title: { ru: "Награды", en: "Awards" },
      href: "/awards",
    },
    blog: {
      title: { ru: "Блог", en: "Blog" },
      href: "/blog",
    },
    reviews: {
      title: { ru: "Отзывы", en: "Reviews" },
      href: "/reviews",
    },
    service: {
      art: {
        title: { ru: "Иллюстрации", en: "Art" },
        href: "/service/art",
      },
      branding: {
        title: { ru: "Стиль", en: "Branding" },
        href: "/service/branding",
      },
      style: {
        title: { ru: "Стиль", en: "Branding" },
        href: "/service/style",
      },
      sites: {
        title: { ru: "Сайты", en: "Web" },
        href: "/service/sites",
      },
      design: {
        title: { ru: "Дизайн", en: "Design" },
        href: "/service/design",
      },
      video: {
        title: { ru: "Видео", en: "Video" },
        href: "/service/video",
      },
      games: {
        title: { ru: "Игры", en: "Games" },
        href: "/service/games",
      },
      arvr: {
        title: { ru: "AR/VR", en: "AR/VR" },
        href: "/service/ar-vr",
      },
      interfaces: {
        title: { ru: "Интерфейсы", en: "Interfaces" },
        href: "/service/interfaces",
      },
      marketing: {
        title: { ru: "Маркетинг", en: "Integrated Marketing" },
        href: "/service/marketing",
        href_en: "/service/smm-b2b",
      },
    },
    cases: {
      title: { ru: "Все проекты", en: "All" },
      href: "/cases",
    },
    jobs: {
      title: { ru: "Работа у нас", en: "Careers" },
      href: "https://case.beaversbrothers.ru/jobs",
    },
    contacts: {
      title: { ru: "Контакты", en: "Contact us" },
      href: "/contacts",
    },
    en: {
      title: { ru: "En", en: "Ru" },
      href: { ru: "https://dabb.pro/", en: "https://beaversbrothers.ru/" },
    },
    brief: {
      title: { ru: "Бриф", en: "Brief" },
      href: "/brief",
    },
    agreement: {
      title: {
        ru: "Согласие на обработку персональных данных",
        en: "Согласие на обработку персональных данных",
      },
      href: "/agreement",
    },
    policy: {
      title: {
        ru: "Политика конфиденциальности",
        en: "Политика конфиденциальности",
      },
      href: "/policy",
    },
  },
}

export type StaticContext = typeof STATIC_CONTEXT
